var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelefono(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47715 0 0 4.47715 0 10C0 15.5229 4.47715 20 10 20C15.5229 20 20 15.5229 20 10C20 4.47715 15.5229 0 10 0ZM6.40625 3.97217C6.61228 3.96002 6.79852 4.08317 6.9397 4.30175L8.30688 6.89452C8.45083 7.20175 8.36903 7.53072 8.1543 7.75023L7.52808 8.37645C7.48943 8.42942 7.464 8.48907 7.46338 8.55467C7.70353 9.48425 8.432 10.3417 9.07473 10.9314C9.71743 11.5211 10.4082 12.3194 11.3049 12.5085C11.4158 12.5395 11.5516 12.5505 11.6309 12.4768L12.3584 11.7359C12.6095 11.5455 12.9728 11.4533 13.241 11.6089H13.2532L15.7202 13.0652C16.0823 13.2922 16.1198 13.7309 15.8606 13.9978L14.1614 15.6836C13.9104 15.9409 13.5771 16.0275 13.2532 16.0278C11.8207 15.9849 10.4672 15.2819 9.3555 14.5593C7.53067 13.2318 5.85678 11.5852 4.80592 9.59595C4.40288 8.76178 3.92943 7.69745 3.97462 6.76638C3.97865 6.41612 4.07342 6.07297 4.32008 5.8472L6.0193 4.14798C6.15167 4.03535 6.28262 3.97947 6.40625 3.97217Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelefono);
export default __webpack_public_path__ + "static/media/telefono.423e71e029513450277c0cbc32bc7273.svg";
export { ForwardRef as ReactComponent };